import { Link } from "react-router-dom";
import { AiFillDashboard } from "react-icons/ai";

const Breadcrumb = ({ pageName }) => {
  return (
    <div className="mb-4 sm:mb-6 flex flex-col sm:flex-row gap-2 sm:gap-3 items-start sm:items-center justify-between">
      <h2 className="font-semibold text-xl sm:text-2xl text-[#1C1410]">
        {pageName}
      </h2>

      <nav>
        <ol className="flex items-center flex-wrap gap-1.5 text-sm">
          <li className="flex items-center gap-1.5">
            <AiFillDashboard className="text-[#D97706] flex-shrink-0" />
            <Link
              className="font-medium text-[#8A7560] hover:text-[#D97706] transition-colors"
              to="/dashboard"
            >
              Dashboard
            </Link>
            <span className="text-[#D9C4A8]">/</span>
          </li>
          <li className="font-medium text-[#D97706] truncate max-w-[160px] sm:max-w-none">
            {pageName}
          </li>
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumb;